export function trackOffer(event: string, plan?: string) {
  // First-party event hook. The approved analytics adapter may consume this event.
  window.dispatchEvent(new CustomEvent('packprintmail:analytics', { detail: { event, plan, mobile: matchMedia('(max-width: 760px)').matches, path: location.pathname } }))
}
